// extracted by mini-css-extract-plugin
export var active = "_i8-7";
export var blink = "_i8-8";
export var dropDownSelector = "_i8-4";
export var dropDownWrapper = "_i8-3";
export var fakeCursor = "_i8-6";
export var fontSizeButton = "_i8-9";
export var formQuillEditor = "_i8-0";
export var pressed = "_i8-a";
export var qlBlank = "_i8-1";
export var textFormattingToolbar = "_i8-2";
export var textToolbarOption = "_i8-5";